<template>
  <div>
    <div
      @click="show = !show"
      class="flex items-center space-x-4 text-lg font-bold"
    >
      <span
        class="transform transition-all"
        :class="show ? 'rotate-90' : '-rotate-90'"
      >
        <i v-html="$icons.chevron_right"></i>
      </span>
      <span>
        {{ data.group_name }}
      </span>
    </div>
    <collapse-transition-group-component>
      <ul v-show="show" key="1" class="space-y-2 pt-2">
        <li
          v-for="item in data.options"
          :key="item.name"
          class="flex items-center space-x-3"
        >
          <input
            type="checkbox"
            v-model="selected"
            :value="item.value"
            :id="item.value"
            class="dark:bg-ontick-steel-500 rounded border-none bg-gray-50"
          />
          <label :for="item.value">{{ item.name }}</label>
        </li>
      </ul>
    </collapse-transition-group-component>
  </div>
</template>

<script>
import collapseTransitionGroupComponent from "../expanded/collapse.transition-group.component.vue";
export default {
  components: { collapseTransitionGroupComponent },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      show: true,
      selected: [],
    };
  },
  watch: {
    selected() {
      this.$emit("selected", this.selected);
    },
  },
};
</script>

<style></style>
